import { fetchAuthSession } from 'aws-amplify/auth';

export const getAuthToken = async () => {
    const { tokens: session } = await fetchAuthSession();
    return session?.idToken?.toString();
};
